import { FirestoreCollections, ID, NewTag, Tag } from '@griply/types';
import { withRoles } from '@griply/utils';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';

export type CreateTagOptions<
  TDocRef = unknown,
  TCollectionRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  tag: NewTag;
  userId: ID;
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollectionRef;
  doc: (
    collectionRef: NoInfer<TCollectionRef>,
    ...rest: string[]
  ) => TDocRef & { id: string };
  setDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void> | void;
  db: TDb;
  serverTimestamp: () => TFieldValue;
  onWriteError: (error: unknown) => void;
};

export const createTag = async <
  TDocRef,
  TCollectionRef,
  TFieldValue,
  TDb = FirestoreInstance,
>({
  tag,
  userId,
  collection,
  doc,
  setDoc,
  db,
  serverTimestamp,
  onWriteError,
}: CreateTagOptions<
  TDocRef,
  TCollectionRef,
  TFieldValue,
  TDb
>): Promise<Tag> => {
  const collectionRef = collection(db, FirestoreCollections.Tags);
  const newDoc = doc(collectionRef);
  const _tag = withRoles(tag, userId);

  detachWrite(
    setDoc(newDoc, {
      ..._tag,
      id: newDoc.id,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }),
    onWriteError,
  );
  const now = new Date();

  return {
    ..._tag,
    id: newDoc.id,
    createdAt: now,
    updatedAt: now,
  };
};
